import { useEffect, useRef } from "react";
import { createNudgeSocket } from "./nudgeSocket";

// Mount ONCE per staff app, where the active show (and ring) is known. Opens the
// staff change-nudge socket for that show and writes its health and nudges into
// the nudge store, which the app's change check reads (see nudgeStore.js). It
// returns nothing and renders nothing: a socket that is down is never the
// user's problem (and never a scribe's: no warning, no banner).
//
//   url          the score-api WebSocket URL (VITE_SCORE_WS_URL). Empty means no
//                socket (local dev, an env without the WebSocket yet).
//   accessToken  the signed-in user's Cognito access token (read afresh on each
//                reconnect, so a silent renew is picked up).
//   orgId        the active org.
//   enabled      false holds no socket at all.
//
// NEVER mount this on the public phone scoreboard: it cannot authenticate and
// stays on change checks (pinned by a test in score-fe).
export function useChangeNudgeSocket({
  url,
  accessToken,
  orgId,
  showId,
  ring,
  enabled = true,
  WebSocketImpl,
}) {
  const authRef = useRef({ token: accessToken, orgId });
  authRef.current = { token: accessToken, orgId };
  const hasToken = Boolean(accessToken);

  useEffect(() => {
    if (!enabled || !url || !showId || !hasToken) return undefined;
    const socket = createNudgeSocket({
      url,
      getAuth: () => authRef.current,
      showId,
      ring,
      WebSocketImpl,
    });
    socket.start();
    return () => socket.stop();
  }, [enabled, url, showId, ring, orgId, hasToken, WebSocketImpl]);
}

export default useChangeNudgeSocket;
